import { UserActivationResolver } from 'app/auth/user-activation.resolver';
import { ForgotPasswordGuard } from './security/forgot-password/forgot-password.guard';
import { UserResolver } from './../auth/user.resolver';
import { ResetPasswordComponent } from './security/reset-password/reset-password.component';
import { ForgotPasswordComponent } from './security/forgot-password/forgot-password.component';
import { LoginAndRegisterComponent } from './security/login-and-register/login-and-register.component';
import { LoginTypesComponent } from './security/login-types/login-types.component';
import { AuthGuard } from './../auth/auth.guard';
import { SecurityComponent } from './security/security.component';
import { Routes } from '@angular/router';
import { UserProfileComponent } from './security/user-profile/user-profile.component';


export const securityRoutes: Routes = [
    { path: 'security', pathMatch: 'full', redirectTo: 'security/login' },
    {
        path: 'security', component: SecurityComponent, children: [
            { path: 'login', component: LoginTypesComponent },
            { path: ':type/login', component: LoginAndRegisterComponent },
            { path: ':type/forgot-password', component: ForgotPasswordComponent },
            { path: 'forgot-password/:token', component: ForgotPasswordComponent, canActivate: [ForgotPasswordGuard] },
            { path: 'change-password', component: ResetPasswordComponent, canActivate: [AuthGuard] },
            { path: 'profile', component: UserProfileComponent, canActivate: [AuthGuard] },
            { path: 'activate-user/:type/:email/:password', component: ResetPasswordComponent, resolve: { tempPassword: UserActivationResolver }}
        ]
    }
]


// WEBPACK FOOTER //
// ./src/app/security/security.routes.ts